import styled from 'styled-components';

export const ResultBox = styled.div`
  background-color: ${(props) => props.theme.backgroundLighter};
  margin: 15px 0;
  padding: 26px 10px 23px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ConfidenceBox = styled.div`
  align-items: center;
  display: flex;
  margin: 5px 0 0;
  padding: 5px 10px 5px;
  border-radius: 4px;
  border: solid 1px ${(props) => props.theme.keyline};
  background-color: ${(props) => props.theme.background};
`;

export const ModalBackground = styled.div`
  background-color: rgba(53, 53, 53, 0.3);
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  background-color: ${(props) => props.theme.background};
  border-radius: 4px;
  padding: 30px;
  width: 100%;
  max-width: 580px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const IconWrapper = styled.div`
  display: inline-block;
  width: 31px;
  height: 28px;
  cursor: pointer;
`;

export const Heading = styled.h2`
  font-size: 18px;
  font-weight: bold;
`;

export const List = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  > li {
    padding: 8px 0px;
  }
`;

export const BottomList = styled(List)`
  > li {
    padding: 12px 0px;
  }
`;

export const Li = styled.li`
  display: flex;
`;

export const BottomListWrapper = styled.div`
  margin-top: 30px;
`;

export const ModalContentWrapper = styled.div`
  max-width: 505px;
`;

export const LongText = styled.span`
  display: inline-block;
  overflow: hidden;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.backgroundLight};
`;

export const EmailWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
  margin-bottom: 20px;
`;
